import gql from 'graphql-tag';

export default gql`
  query getSeatSizesMap {
    order {
      items {
        id
        __typename
        ...FlightOrderItemFragment
      }
    }
  }
  fragment FlightOrderItemFragment on OrderItem {
    ... on FlightOrderItem {
      flight {
        id
      }
      seatmap {
        seatSizesMap {
          id
          name
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
